module.exports = __webpack_public_path__ + "static/media/matilde-special-crown-tired.8ce4fb63.png";